const numberWithSeparator = (number, separator) =>
  number.replace(/\B(?=(\d{3})+(?!\d))/g, separator);

const NON_BREAKING_SPACE = '\u00A0';

export function getSeparators(locale) {
  switch (locale) {
    case 'fr':
    case 'de':
    case 'es':
    case 'it':
      return { symbolPosition: 'end', numberSeparator: NON_BREAKING_SPACE, decimalSeparator: ',' };
    case 'ar':
    case 'en':
    case 'nl_BE':
    case 'zh':
    case 'zh_TW':
      return { symbolPosition: 'start', numberSeparator: ',', decimalSeparator: '.' };
    case 'nl':
      return {
        symbolPosition: 'start',
        numberSeparator: NON_BREAKING_SPACE,
        decimalSeparator: ',',
      };
    default:
      return { symbolPosition: 'start', numberSeparator: ',', decimalSeparator: '.' };
  }
}

// Accepts a string with two decimal places.
export function numberToCurrency(amount, locale, sign, currencyCode, showDecimals = true) {
  if (!amount) return null;

  const isUAE = currencyCode === 'AED';
  const isTaiwan = currencyCode === 'TWD';
  const isKuwait = currencyCode === 'KWD';
  const precision = isKuwait ? 3 : 2;
  let amountFixed = parseFloat(amount).toFixed(precision);
  let prepend = '';

  if (amountFixed < 0) {
    prepend = '-';
    amountFixed = String(parseFloat(Math.abs(amountFixed)).toFixed(precision));
  }

  const formatDecimalPlaces = (numberSeparator, decimalSeparator) => {
    const [major, minor] = amountFixed.split('.');
    const formattedMajor = numberWithSeparator(major, numberSeparator);
    const formattedMinor = showDecimals || minor > 0 ? `${decimalSeparator}${minor}` : '';

    switch (true) {
      case isTaiwan:
      case isUAE:
        return minor > 0 ? `${formattedMajor}${formattedMinor}` : formattedMajor;
      case isKuwait:
        return `${formattedMajor}${decimalSeparator}${minor}`;
      default:
        return `${formattedMajor}${formattedMinor}`;
    }
  };

  const addSymbol = (position, number) => {
    if (position === 'start') {
      return `${sign}${isUAE || isKuwait ? NON_BREAKING_SPACE : ''}${number}`;
    }
    return `${number}${NON_BREAKING_SPACE}${sign}`;
  };

  const { symbolPosition, numberSeparator, decimalSeparator } = getSeparators(locale);

  return `${prepend}${addSymbol(
    symbolPosition,
    formatDecimalPlaces(numberSeparator, decimalSeparator),
  )}`;
}
